const HTTP_BAD_REQUEST = 400;
const HTTP_NOT_FOUND = 404;
const HTTP_CONFLICT = 409;
const PATIENTS_NOT_ENABLED_CODE = 'ITERO_PATIENTS_NOT_ENABLED';

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

// The backend sends ITERO_PATIENTS_NOT_ENABLED with a 409; on /patients a bare 409 means the same.
export function isPatientSearchDisabled(error: unknown): boolean {
    if (!isRecord(error) || !isRecord(error.response)) return false;
    const { status, data } = error.response;
    const code = isRecord(data) && isRecord(data.error) ? data.error.code : undefined;
    return status === HTTP_CONFLICT || code === PATIENTS_NOT_ENABLED_CODE;
}

const AXIOS_TIMEOUT_CODES: ReadonlySet<string> = new Set(['ECONNABORTED', 'ETIMEDOUT']);

export function isTimeoutError(error: unknown): boolean {
    return isRecord(error) && typeof error.code === 'string' && AXIOS_TIMEOUT_CODES.has(error.code);
}

// A malformed or unknown id: retrying can't help, unlike a timeout or a 5xx.
export function isUnavailableError(error: unknown): boolean {
    if (!isRecord(error) || !isRecord(error.response)) return false;
    const { status } = error.response;
    return status === HTTP_BAD_REQUEST || status === HTTP_NOT_FOUND;
}
